import React, { useCallback } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Text from '../../../components/common/Text'
import UsernameTableColumn from '../../../components/UsernameTableColumn'
import ButtonViewTable from '../../../components/ButtonViewTable'
import { Port } from '../../../services/port/port-typed'
import { getColorDcaPlanText, replaceStatusDcaPlan, useRouter } from '../../../../utils/helper'
import { useGetDcas } from '../../../services/dca/dca-query'
import * as paths from '../../../constants/path'
import ListPage from '../../../components/templates/ListPage'
import { DcaPlans, EnumFrequencyDcaType } from '../../../services/dca/dca-typed'
import dayjs from 'dayjs'
import { pascalize } from 'humps'

const column = (onClick: any) => [
  {
    title: 'Reference',
    dataIndex: 'reference',
    render: (text: string, dca: DcaPlans) => {
      const { externalReference } = dca || {}
      return <Text>{externalReference || '-'}</Text>
    },
  },
  // {
  //   title: 'Email',
  //   dataIndex: 'email',
  //   render: (text: string, dca: DcaPlans) => {
  //     const { email, id } = dca.user || {}
  //     return email ? (
  //       <Link to={`/users/${id}`}>
  //         <Text>{email}</Text>
  //       </Link>
  //     ) : (
  //       <Text>''</Text>
  //     )
  //   },
  // },
  {
    title: 'Price',
    dataIndex: 'price',
    render: (text: string, record: DcaPlans) => {
      const { value } = record
      let price = Number(value)
      return <Text>{price.toLocaleString()}</Text>
    },
  },
  {
    title: 'Date',
    dataIndex: 'date',
    render: (text: string, record: DcaPlans) => {
      const { date, type } = record
      const dateNum = Number(date)
      const displayDate =
        type === EnumFrequencyDcaType.WEEKLY
          ? `${dayjs()
              .day(dateNum)
              .format('dddd')}`
          : `Every ${date} of the month`
      return <Text>{displayDate}</Text>
    },
  },
  {
    title: 'Type',
    dataIndex: 'type',
    render: (text: string, record: DcaPlans) => {
      const { type } = record
      return <Text>{pascalize(type)}</Text>
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (text: string, record: DcaPlans) => {
      const { status } = record
      return <Text color={getColorDcaPlanText(status)}>{replaceStatusDcaPlan(status)}</Text>
    },
  },
  {
    title: '',
    width: 100,
    dataIndex: 'buttonView',
    render: (text: string, dca: DcaPlans) => {
      return <ButtonViewTable onClick={onClick.bind(null, dca.id)} />
    },
  },
]

const DcaList = () => {
  const { push, query } = useRouter()
  const { q, page } = query
  const { data: dcas } = useGetDcas({ q, page })

  console.log(dcas)

  const history = useHistory()
  const setQueryParam = useCallback(
    params => {
      push(paths.dca({ queryParam: { ...query, ...params } }))
    },
    [push, query],
  )
  const onSearch = useCallback(
    text => {
      setQueryParam({ q: text, page: 1 })
    },
    [setQueryParam],
  )
  const onPageChange = useCallback(
    page => {
      setQueryParam({ page })
    },
    [setQueryParam],
  )
  const onViewClick = useCallback(
    (dcaId: string) => {
      history.push(paths.dcaDetail({ routeParam: { dcaId } }))
    },
    [history],
  )

  return (
    <ListPage
      searchInputProps={{ onSearch, value: q }}
      tableProps={{
        columns: column(onViewClick),
        data: dcas?.items,
        onPageChange,
        pagination: dcas?.meta,
      }}
    />
  )
}

export default DcaList
